export default __webpack_public_path__ + "static/media/rotating-categories.15365870.svg";